<a
  class="shape-ui-list"
  mat-icon-button
  (mousedown)="preventModifyingSelection($event)"
  (click)="showTagEditor($event)"
>
  <mat-icon class="material-symbols-outlined">edit</mat-icon>
</a>
